import React, { PureComponent } from 'react';
import MoxiModalContext from './MoxiModalContext';

class MoxiModalProvider extends PureComponent {
  render() {
    return <MoxiModalContext.Provider value={this.props}>{this.props.children}</MoxiModalContext.Provider>;
  }
}

export default MoxiModalProvider;
